module.exports = __webpack_public_path__ + "static/media/galerija_2021 (4).60d19764.jpg";